export default "__VITE_ASSET__CZE1LsjG__"